import React, { useEffect, useState } from "react";
import "./App.css";
import ParentApp from "@mondora/microfrontends/lib/ParentApp";
import { useDispatch, useSelector } from "react-redux";
import { ParentInterface } from "./interfaces/parent";
import MainSpinner from "./components/general/mainSpinner";

import { setAuthData } from "./actions/auth";
import { setMainData } from "./actions/main";
import { setParentData } from "./actions/parent";
import MainRoutes from "./routes";
import { RootState } from "./reducers/store";
import { getMeteringPackage, getUserPackage } from "./actions/userPackage";
import {
    API_BE4FE_URL,
    APP_GAINSIGHT_TAG_KEY,
    APP_ONE_TRUST_ENABLED,
    DEV_PARENT_APP_PARAMS,
    USE_DEV_CREDENTIALS,
} from "./config";
import GenericError from "./components/genericError";
import { ThemeProvider } from "@ts-digital/vrc";
import VaporThemeProvider from "@vapor/react-material/styles";
import UIElements from "./components/general/uiElements";
import { identifyGainsightPX, initializeGainsightPX } from "./gainsight";

function App() {
    const { pathname, hash } = window.location;
    const main = useSelector((state: RootState) => state.main);
    const [mainSpinner, showMainSpinner] = useState(false);
    const dispatch: any = useDispatch();

    useEffect(() => {
        if (
            USE_DEV_CREDENTIALS &&
            main.accountantUuid === "" &&
            main.companyUuid === ""
        ) {
            console.log("Using Dev Credentials");

            const authData = {
                token: DEV_PARENT_APP_PARAMS.user.token,
                id: DEV_PARENT_APP_PARAMS.user.id,
            };

            const mainData =
                Math.random() > 0.5
                    ? {
                          // Company
                          companyUuid: DEV_PARENT_APP_PARAMS.item.id,
                      }
                    : {
                          // Studio
                          accountantUuid: DEV_PARENT_APP_PARAMS.item.id,
                      };

            dispatch(setAuthData(authData));
            dispatch(setMainData(mainData));
            dispatch(setParentData(DEV_PARENT_APP_PARAMS));
        } else {
            new ParentApp({
                onLaunch: (params: ParentInterface) => {
                    const authData = {
                        token: params.user.token,
                        id: params.user.id,
                    };

                    const mainData =
                        params.item.classifier !== "STUDIO"
                            ? {
                                  companyUuid: params.item.id,
                              }
                            : {
                                  accountantUuid: params.item.id,
                              };

                    dispatch(setAuthData(authData));
                    dispatch(setMainData(mainData));
                    dispatch(setParentData(params));
                    if (
                        APP_ONE_TRUST_ENABLED !== "true" ||
                        (APP_ONE_TRUST_ENABLED === "true" &&
                            params?.cookieConsents?.C0006)
                    ) {
                        initializeGainsightPX(APP_GAINSIGHT_TAG_KEY);
                        identifyGainsightPX(params);
                    }
                },
                //parentOrigin: APP_PARENT_URL // "https://app.teamsystemdigital.com"
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!hash.includes("#")) window.location.href = `${pathname}#/${hash}`;
    }, [hash, pathname]);

    useEffect(() => {
        if (main.companyUuid || main.accountantUuid) {
            showMainSpinner(true);
            dispatch(getUserPackage())
                .then((res: any) => {
                    showMainSpinner(false);
                })
                .catch(() => {
                    showMainSpinner(false);
                });
            dispatch(getMeteringPackage());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [main.companyUuid, main.accountantUuid]);

    if (!API_BE4FE_URL) {
        return <GenericError />;
    }

    return (
        <>
            {mainSpinner && <MainSpinner />}
            <VaporThemeProvider>
                <ThemeProvider>
                    <UIElements />
                    <MainRoutes />
                </ThemeProvider>
            </VaporThemeProvider>
        </>
    );
}

export default App;
